<template>
  <div class="mb-8">
    <v-card class="mx-auto mb-3">
      <div id="filters">
        <template>
          <v-toolbar flat>
            <v-toolbar-title>
              <p class="mb-0">{{ $t("SENDING_GROUP_NOTIFICATION") }}</p>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-btn
              v-if="!$vuetify.breakpoint.mdAndUp"
              :to="{name:'StudentNominate'}"
              color="secondary"
              dark
          >{{ $t("STUDENT_NOMINATE_APPLICATION") }}
          </v-btn>
          <v-form ref="form">
            <v-container>
              <v-row>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12">
                  <v-select
                      v-model="appStatus"
                      :items="serverTranslateArray(this.status, 'name')"
                      :label="$t('APPLICATION_CASES')"
                      item-text="name"
                      item-value="mongo_id"
                      outlined
                      small-chips
                  >
                  </v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.yearId"
                      :items="serverTranslateArray(this.years, 'name')"
                      :label="$t('ACADEMIC_YEAR')"
                      clearable
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="12" sm="12" xs="12">
                  <v-select
                      v-model="filterItems.semesterId"
                      :items="serverTranslateArray(this.semesters, 'name')"
                      :label="$t('ACADEMIC_SEMESTER')"
                      clearable
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4" xs="4">
                  <v-select
                      v-model="filterItems.certificatesCategoryFilter"
                      :items="serverTranslateArray(this.certificateCategoriesList, 'name')"
                      :label="$t('CERTIFICATE')"
                      item-text="name"
                      item-value="id"
                      outlined
                      @change="selectCertType()"
                  ></v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4" xs="4">
                  <v-select
                      v-model="filterItems.certificateTypeFilter"
                      :items="serverTranslateArray(this.certificateTypesList, 'name')"
                      :label="$t('SPECIALIZATION')"
                      item-text="name"
                      item-value="id"
                      outlined
                      @change="selectCertType()"
                  ></v-select>

                </v-col>
                <v-col
                    v-if="(filterItems.certificateTypeFilter == 22 && foreignCertificatesList.length) || (filterItems.certificateTypeFilter == 61 && egyptianCertificatesList.length)"
                    class="ma-0" cols="12" lg="4" md="4"
                    sm="4"
                >
                  <v-select
                      v-model="certificateForeignId"
                      :items="filterItems.certificateTypeFilter == 22 ? serverTranslateArray(this.foreignCertificatesList, 'name') : serverTranslateArray(this.egyptianCertificatesList, 'name') "
                      :label="$t('ADMISSION_DATA.STEP2.CERTIFICATE_NAME')"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4">
                  <v-select
                      v-model="filterItems.countryId"
                      :disabled="filterItems.certificatesCategoryFilter !== 17"
                      :items="serverTranslateArray(this.countriesList, 'name')"
                      :label="$t('ADMISSION_DATA.STEP2.CERT_FROM_COUNTRY')"
                      :value="filterItems.countryId"
                      item-text="name"
                      item-value="id"
                      outlined
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                  <v-menu
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="startApplicationDate"
                          :label="$t('APPLY_APPLICATION_DATE') +$t('FROM')"
                          :rules="startDateRules"
                          clearable
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="startApplicationDate"
                        :max="maxDate"
                        :min="minDate"
                        @input="startDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="ma-0" cols="12" lg="6" md="6" sm="6">
                  <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          ref="endDate"
                          v-model="endApplicationDate"
                          :label="$t('APPLY_APPLICATION_DATE') +$t('TO')"
                          :rules="endDateRules"
                          clearable
                          prepend-icon="event"
                          readonly
                          v-bind="attrs"
                          v-on="on"

                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="endApplicationDate"
                        :max="maxDate"
                        :min="minDate"
                        @input="endDateMenu = false"></v-date-picker>
                  </v-menu>
                </v-col>

              </v-row>
              <v-row>
                <!--                <v-col class="ma-0" cols="4" lg="4" md="12" sm="12" xs="12">-->
                <!--                  <v-checkbox-->
                <!--                      v-model="withSubmittedTotalOnly"-->
                <!--                      :label="$t('HIDE_WITHOUT_SUBMITTED_TOTAL')"-->
                <!--                      class="ma-0"-->
                <!--                      color="primary"></v-checkbox>-->
                <!--                </v-col>-->
                <v-col class="ma-0" cols="6" lg="6" md="6" sm="6" xs="6">
                  <div class="d-flex align-center">
                    <label class="mr-2">
                      {{ $t("UserData.CERTIFICATE_PERC") }}
                    </label>
                    <v-select
                        v-model="selectedOperator"
                        :items="operators"
                        class="mr-2"
                        dense
                        outlined
                        style="max-width: 80px"
                    ></v-select>

                    <v-text-field
                        v-model.number="inputPercFilterValue"
                        :placeholder="$t('ENTER_PERC_NUM')"
                        dense
                        outlined
                        step="0.01"
                        style="max-width: 130px"
                        type="number"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col class="ma-0" cols="6" lg="6" md="6" sm="6" xs="6">
                  <div class="d-flex align-center">
                    <v-select
                        v-model="totSelcVal"
                        :items=totSlc
                        :placeholder="$t('CHOOSE_TOTAL_TYPE')"
                        item-text="name"
                        item-value="value"
                    >
                    </v-select>

                    <v-select
                        v-model="selectedTotOperator"
                        :items="totOperators"
                        class="mr-2"
                        dense
                        outlined
                        style="max-width: 80px"
                    ></v-select>

                    <v-text-field
                        v-model.number="inputTotFilterValue"
                        :placeholder="$t('ENTER_TOT_NUM')"
                        dense
                        outlined
                        step="0.01"
                        style="max-width: 130px"
                        type="number"
                    ></v-text-field>

                  </div>
                </v-col>

                </v-row>

              <v-row>

                <v-col class="ma-0" cols="6" lg="6" md="6" sm="4">
                  <v-select
                      v-model="filterItems.preQualYear"
                      :items="serverTranslateArray(this.years, 'name')"
                      :label="$t('ADMISSION_DATA.STEP2.YEAR')"
                      item-text="name"
                      item-value="id"
                      outlined
                      clearable
                  ></v-select>
                </v-col>

                 <v-col class="ma-0" cols="6" lg="6" md="6" sm="6" xs="6">
                  <v-text-field
                      v-model="filterItems.studentLimit"
                      :label="$t('FILTERS.STUDENT_LIMIT')"
                      :rules="$store.state.Rules.numberField"
                      counter="1000"
                      outlined
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row>
                <v-col class="ma-0" cols="12" lg="4" md="4" sm="4">
                  <v-checkbox
                      v-model="paidOnly"
                      :label="$t('PAID')"
                      class="ma-0"
                      color="primary"
                  ></v-checkbox>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="ma-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-radio-group v-model="searchWithId" class="ma-0" row>
                    <v-radio :label="$t('STUDENT_NAME')" value="1"></v-radio>
                    <v-radio :label="$t('IDENTITY')" value="2"></v-radio>
                    <v-radio :label="$t('APPID')" value="3"></v-radio>
                    <v-radio :label="$t('UserData.DESIRE_NUMBER')" value="4"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col v-if="searchWithId==='2'" class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="identityNum"
                      :label="$t('WithIDENTITYTEXT')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>

                <v-col v-if="searchWithId==='3'"
                       class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="appId"
                      :label="$t('WITHAPPID')"
                      :rules="$store.state.Rules.noSpecialLetter"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>

                <v-col v-if="searchWithId==='4'"
                       class="py-0" cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-text-field
                      v-model="desireNum"
                      :label="$t('WITHDESIRENUM')"
                      :rules="$store.state.Rules.numberField"
                      counter="25"
                      outlined
                  ></v-text-field>
                </v-col>


                <v-col v-if="searchWithId==='1'"
                       class="py-0"
                       cols="12" lg="12" md="12" sm="12" xs="12">
                  <v-autocomplete
                      v-model="studentId"
                      :items="students"
                      :label="$t('WithNAMETEXT')"
                      :loading="searchIsLoading"
                      :search-input.sync="studentSearch"
                      clearable
                      item-text="name"
                      item-value="id"
                      no-filter
                      outlined
                      return-object
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-card-actions class="pa-5">
                <v-container class="px-5">
                  <v-row>
                    <v-col class="pa-1" cols="auto">
                      <v-btn
                          class="mx-2"
                          color="primary"
                          @click="showScopeTreeFn()">
                        {{ $t('SCOPE') }}
                        <v-icon right>mdi-navigation</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col class="pa-1" cols="auto">
                      <download-excel
                          :fetch="fetchExportedData"
                          :fields="serverTranslateDictKeyName(jsonFields)"
                          :title="[title]"
                          name="StudentsApplicationsNotifications.xls"
                          worksheet="Students Worksheet"
                      >
                        <v-btn :fab="!$vuetify.breakpoint.mdAndUp"
                               :small="!$vuetify.breakpoint.mdAndUp"
                               color="secondary"
                        >
                          <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('EXPORT') }}</span>
                          <v-icon :right="$vuetify.breakpoint.mdAndUp">mdi-cloud-download</v-icon>
                        </v-btn>
                      </download-excel>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="pa-1" cols="auto">
                      <v-btn color="primary" dark @click="searchAppliactions">
                        {{ $t("SEARCH") }}
                      </v-btn>
                    </v-col>
                    <v-col class="pa-1 mx-2" cols="auto">
                      <v-btn
                          class="white--text"
                          color="darken3"
                          @click="reset"
                      >
                        {{ $t("RESET") }}
                      </v-btn>
                    </v-col>
                    <v-col class="pa-1 " cols="auto">
                      <v-btn
                           v-if="canSendNotification||canAcceptRefuseWait"
                          :disabled="!sendingApplicationsNotEmpty"
                          class="ma-1"
                          color="primary"
                          @click="openMessageDialog"
                      >
                        {{ $t("GROUP_CONTROL") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-form>
        </template>
      </div>
    </v-card>
    <v-col v-if=" showAlert===true " col2="12" lg="12">
      <v-alert type="error">
        {{ errorMessages }}
      </v-alert>
    </v-col>

    <v-card class="mx-auto" outlined>
      <div id="inspire">
        <v-data-table
            :fixed-header="true"
            :footer-props="{
                 showFirstLastPage: true,
                 firstIcon: 'mdi-arrow-collapse-left',
                 lastIcon: 'mdi-arrow-collapse-right',
                 prevIcon: 'mdi-arrow-left',
                 nextIcon: 'mdi-arrow-right',
                 itemsPerPageOptions: [20, 40, 60, 80, 100,500,1000]
                 }"
            :headers="headers"
            :hide-default-footer="applications.length > 0 ? false : true"
            :hide-default-header="true"
            :items="applications"
            :items-per-page="20"
            :loading="loading"
            :options.sync="appOptions"
            :server-items-length="total"
            class="elevation-1 "

            sort-by="name"
        >

          <template v-slot:header="{ props }">
            <tr>

              <th class="d-flex mb-2  align-items-center ">

                <v-checkbox
                    v-model="selectAll"
                    class="text-center"
                    @change="toggleSelectAll"
                ></v-checkbox>
                <label class="align-self-center mt-2">{{ $t("SELECT_ALL_PER_PAGE") }}</label>
              </th>
              <th v-for="header in props.headers" :key="header.text" class="text-center" style="cursor: pointer;"
                  @click="changeSort(header)">
                {{ header.text }}
                <!-- عرض سهم الفرز لو هذا العمود هو الحالي -->
                <v-icon v-if="appOptions.sortBy[0] === header.value" small>
                  {{ appOptions.sortDesc[0] ? 'mdi-arrow-down' : 'mdi-arrow-up' }}
                </v-icon>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center" style="width:5%;">
                <v-checkbox
                    v-model="item.selected"
                    :input-value="item.selected"
                    :label="null"
                    @change="checkItem(item)"
                ></v-checkbox>
              </td>
              <td class="text-center">{{ serverTranslate(item.studentName) }}</td>
              <td class="text-center">{{ item.identityNumber }}</td>
              <td class="text-center">{{ item.appNum }}</td>
              <td class="text-center">{{ serverTranslate(item.facultyName) }}</td>
              <td class="text-center">{{ item.desireNumber }}</td>
              <td class="text-center">{{ item.studentPercentage }}</td>
              <td class="text-center">{{ item.studentTotal }}</td>
              <td class="text-center">{{ item.certifiedTotal }}</td>
              <td class="text-center">
                {{
                  item.applicationStatus ?
                      getAppStatusText(item.applicationStatus) : ""
                }}
              </td>


              <td class="text-center">
                <v-btn v-if="item.messages.length>0" color="primary" icon small @click="showMessages(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>

                <!-- Dialog -->
                <v-dialog v-model="messagesDialog" max-width="600px">
                  <v-card>
                    <v-card-title class="text-h6">
                      {{ $t("NOTIFICATIONS") }}
                    </v-card-title>
                    <v-card-text>
                      <ul>
                        <li v-for="(msg, idx) in selectedMessages" :key="idx">
                          <strong>({{ msg.msgDate }})</strong> - {{ msg.msgText }}
                        </li>
                      </ul>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="messagesDialog = false">
                        {{ $t("CLOSE") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert class="mt-2" color="light5" icon="warning">
              {{ $t("NO_DATA") }}
            </v-alert>
          </template>
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title> {{ title }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template v-slot:footer.page-text="props">
            {{ props.pageStart }} - {{ props.pageStop }} {{ $t('PAGE_TEXT') }} {{ props.itemsLength }}
          </template>

        </v-data-table>
      </div>
    </v-card>
    <v-dialog
        v-model="openDialog"
        max-width="150vh"
        @keydown.esc="closeSendingDialog"
        @click:outside="closeSendingDialog"
    >
      <v-card outlined>
        <v-form ref="formMessage" v-model="valid" lazy-validation>
          <v-card-title class="justify-center">
          <span class="headline white--text text-thin">
            {{ $t("FEEDBACK_APPLICATION") }}
          </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert class="mt-2" color="light5" icon="warning">
                {{ $t("NOTIFICATIONS_MESSAGE") }}
              </v-alert>
              <v-alert v-show="showAlert" outlined type="error">
                {{ serverTranslate(errorMessages) }}
              </v-alert>

              <v-row>
                <v-col cols="12">
                  <label class="my-0">{{ $t("UPDATE_APPLY") }}</label>
                  <v-radio-group v-model="applicationStatusOption"
                     :rules="requiredRules"
                     class="mx-4"
                     column>

                    <v-radio
                        :label="$t('MAINTAIN_APPLICATION_STATUS')"
                        color="blue"
                        value=""
                    ></v-radio>

                     <v-radio
                         v-if="canAcceptRefuseWait && appStatus.includes('4')"
                        :label="$t('UNDER_REVIEW_APPLICATION')"
                        :value="APPLICATION_STATUS.SENT_UNDER_REVIEW"
                        color="blue"
                    ></v-radio>

                    <v-radio
                        v-if="canAcceptRefuseWait"
                        :label="$t('ACCEPT_APPLICATION')"
                        :value="APPLICATION_STATUS.ACCEPTED"
                        color="blue"
                    ></v-radio>
                    <v-radio
                         v-if="canAcceptRefuseWait"
                        :label="$t('REJECT_APPLICATION')"
                        :value="APPLICATION_STATUS.REFUSED"
                        color="blue"
                    ></v-radio>
                    <v-radio
                         v-if="canAcceptRefuseWait"
                        :label="$t('COMPLETION_REQUIRED')"
                        :value="APPLICATION_STATUS.FEEDBACK"
                        color="blue"
                    ></v-radio>
                    <v-radio
                         v-if="canAcceptRefuseWait"
                        :label="$t('WAITING_LIST')"
                        :value="APPLICATION_STATUS.WAITING_LIST"
                        color="blue"
                    ></v-radio>
                  </v-radio-group>
                  <v-checkbox
                      ref="sendMailToStudent"
                      v-model="sendMailToStudent"
                      :label="$t('SEND_MAIL_CHECK')"
                      class="d-inline-block my-2"
                      false-value="0"
                      true-value="1"
                  />
                  <v-textarea
                      ref="notificationMessage"
                      v-model="notificationMessage"
                      :label="$t('MESSAGE')"
                      :rules="MessageRules"
                      clearable
                      counter
                      maxlength="10000"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :disabled="sentNotification"
                color="primary"
                dark
                @click="sendAllNotifications"
            >
              {{ $t("SEND_FEEDBACK") }}
            </v-btn>
            <v-btn class="white--text" color="darken3" @click="closeSendingDialog">
              {{ $t("CANCEL") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>


    <pr-scope v-if="showScopeTree == true" :key="componentKey" :scopeFullPath="false" v-on:setScope="onScopeChanged"/>
    <pr-confirmDialog ref="confirm"></pr-confirmDialog>
  </div>
</template>
<script>
import serverTranslations from "@/mixins/serverTranslations";
import scope from "@/components/shared/ScopeTree.vue"
import {EventBus} from "@/plugins/bus";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import Validations from "@/components/shared/validations";
import globalMethodsMixin from "@/mixins/globalMethods.ts";
import {APPLICATION_STATUS} from "@/enums.ts";

export default {
  name: "List",
  components: {
    "pr-scope": scope,
    "pr-confirmDialog": ConfirmDialog
  },
  mixins: [serverTranslations, globalMethodsMixin],

  mounted() {
  if (!this.$store.state.Auth.facultyID) {
    this.showScopeTree = true;
    this.componentKey++;
  }

  this.getFilters();
  this.searchAppliactions(true);

  EventBus.$on("updateRunListAfterAction", () => {
    this.searchAppliactions();
  });
}
,
  watch: {
    searchWithId() {
      this.studentId = null;
      this.students = [];
      this.studentSearch = "";
      this.identityNum = "";
    },
    appOptions: {
      handler() {
        this.searchAppliactions();
      },
      deep: true,
    },
    studentSearch(val) {

      if (!val || val.length < 3) {
        this.students = [];
        return false;
      }
      if (this.searchIsLoading) return;
      const phraseLang = this.isRTL(val) ? "ar" : "en"
      const data = {
        searchData: val,
        semesterId: this.activeAcademicSemester.id,
        yearId: this.activeAcademicYear.id,
      }
      this.searchIsLoading = true;
      this.$http.post("/api/students_admission_apps/search_student/", data)
          .then(
              res => {
                res = res.data.data;
                this.students = res.students.map(item => {
                  return {"id": item.studentId, "name": this.serverTranslateCustom(item.studentName, phraseLang)}
                });
              },
              err => {
                this.showToasted("error", err.response.data.message)
              }
          )
          .then(() => (this.searchIsLoading = false));
    },
  },
  computed: {
     canAcceptRefuseWait() {
      return this.$store.getters.hasPermission("students_admission_apps.can_accept_refuse_wait_Group_app");
    },
    canSendNotification() {
      return this.$store.getters.hasPermission("students_admission_apps.can_texting_Group_student");
    },
    isSearchedWithName() {
      return this.searchWithId === "1";
    },
    isSearchedWithAppId() {
      return this.searchWithId === "3";
    },
    endDateRules() {
      return [
        v =>
            new Date(this.endApplicationDate) >= new Date(this.startApplicationDate) ||
            this.$t("DATE_FROM_TO_VALIDATION")
      ]
    },
    startDateRules() {
      return [
        v => !this.endApplicationDate || new Date(v) <= new Date(this.endApplicationDate) || this.$t("DATE_FROM_TO_VALIDATION")

      ];
    },
    jsonFields() {
      const fields = {
        "اسم الطالب|Student Name": 'studentName',
        'الرقم القومى|identity': 'identityNumber',
        'الكلية|Faculty': 'facultyName',
        'المجموع المعتمد|certifiedTotal': 'certifiedTotal',
        'رقم الطلب|application Id': 'appNum',
        'حالة الطلب|application status': 'applicationStatus',
        'الاشعارات|Notifications': 'messages'
      }

      return fields;
    },
    activeAcademicYear() {
      return this.$store.getters.getActiveAcademicYear;
    },
    activeAcademicSemester() {
      return this.$store.getters.getActiveAcademicSemester;
    },
    title() {
      return this.$t('APPLICATIONS_LIST_TITLE', {
        year: this.filterItems.yearName,
        semester: this.serverTranslate(this.filterItems.semesterName),
        faculty: this.serverTranslate(this.$store.state.Auth.facultyName) || ''
      });
    },
    headers() {
      return [
        {
          text: this.$t("STUDENT_NAME"),
          align: "center",
          sortable: true,
          value: "studentName"
        },
        {
          text: this.$t("IDENTITY"),
          align: "center",
          sortable: false,
          value: "identityNumber"
        },
        {
          text: this.$t("APPID"),
          align: "center",
          sortable: false,
          value: "appNum"
        },
        {
          text: this.$t("FACULTY"),
          align: "center",
          sortable: true,
          value: "facultyName"
        }, {
          text: this.$t("UserData.DESIRE_NUMBER"),
          align: "center",
          sortable: true,
          value: "desireNumber"
        },
        {
          text: this.$t("UserData.CERTIFICATE_PERC"),
          align: "center",
          sortable: true,
          value: "studentPercentage"
        }, {
          text: this.$t("TOTAL_DEGREE"),
          align: "center",
          sortable: true,
          value: "studentTotal"
        }, {
          text: this.$t("CERTIFIED_DEGREE"),
          align: "center",
          sortable: true,
          value: "certifiedTotal"
        },
        {
          text: this.$t("APPLICATION_CASES"),
          align: "center",
          sortable: true,
          value: "applicationStatus"
        },
        {
          text: this.$t("NOTIFICATIONS"),
          align: "center",
          sortable: false,
          value: "messages"
        },
      ];
    }, sendingApplicationsNotEmpty() {
      return Array.isArray(this.sendingApplications) && this.sendingApplications.length > 0;
    }
  },
  data() {
    return {
      paidOnly: false,
      messagesDialog: false,
      selectedMessages: [],
      selectedOperator: '=',
      selectedTotOperator: '=',
      totSelcVal: null,
      inputPercFilterValue: null,
      inputTotFilterValue: null,
      operators: ['=', '>', '<', '>=', '<='],
      totOperators: ['=', '>', '<', '>=', '<='],
      totSlc: [{value: 'total', name: this.$t('TOTAL_DEGREE')}, {value: 'subTot', name: this.$t('CERTIFIED_DEGREE')}],
      valid: true,
      loading: false,
      openDialog: false,
      endDateMenu: false,
      startDateMenu: false,
      startApplicationDate: "",
      certificateCategoriesList: [],
      certificateTypesList: [],
      countriesList: [],
      endApplicationDate: "",
      withSubmittedTotalOnly: false,
      filterItems: {
        facultyId: 0,
        yearId: 0,
        yearName: "",
        semesterId: 0,
        semesterName: "",
        certificatesCategoryFilter: '',
        certificateTypeFilter: '',
        countryId: '',
        studentLimit: '',
        preQualYear: 0
      },
      certificateForeignId: '',
      APPLICATION_STATUS,
      semesters: [],
      years: [],
      scopes: [],
      currentYear: {},
      currentSemester: {},
      studentsNumbers: null,
      studentSearch: "",
      searchWithId: "1",
      searchWithAppId: "1",
      appStatus: "all",
      searchIsLoading: false,
      students: [],
      applications: [],
      identityNum: "",
      appId: "",
      desireNum: "",
      total: 0,
      selectedItems: [],
      selectAll: false, // Whether all items are selected
      //feedbackCheckbox: "0",
      applicationStatusOption: "",
      sendMessageGroup: "1",
      sendMailToStudent: "0",
      sendingApplications: [],
      appOptions: {},
      studentId: "",
      showScopeTree: false,
      componentKey: 0,
      errorMessages: "",
      showAlert: false,
      sentNotification: false,
      MessageRules: [
        v => this.isNotEmpty(v) || this.$t("REQUIRED_FIELD"),
        v => (!!v && v.trim().length > 10) || this.$t("MIN_FIELD") + "10",
        v => (!!v && v.trim().length <= 10000) || this.$t("MAX_FIELD") + "10000"
      ],
      notificationMessage: ""
    };
  },
  methods: {
    showMessages(item) {
      this.selectedMessages = item.messages || [];
      this.messagesDialog = true;
    },
    async fetchExportedData() {
      const data = this.searchedData();
      //data.pageSize=-1
      const response = await this.$http.post("/api/students_admission_apps/list_applications/", data)
      const results = response.data.data.results;
      // Process the messages field to combine into a single string
      const processedResults = results.map(item => {
        const messages = item.messages.map(msg => `(${msg.msgDate}) / ${msg.msgText}`).join(' | ');
        const overriddenStatus = this.getAppStatusText(item.applicationStatus);
        return {
          ...item,
          messages,// Update the messages field
          applicationStatus: overriddenStatus  // override status here
        };
      });

      const exportedData = this.serverTranslateArrayKeys(processedResults,
          ['studentName', 'identityNumber', 'appNum', 'facultyName', 'certifiedTotal', 'applicationStatus', 'messages']);

      if (response.status !== 200) return this.showToasted("error", this.$t("NOT_FOUND_SERVER_ERROR"))
      this.loading = false;
      return exportedData;

    },
    changeSort(header) {
      if (!header.sortable) return;
      const currentSort = this.appOptions.sortBy[0];
      const currentDesc = this.appOptions.sortDesc[0];
      if (currentSort === header.value) {
        this.appOptions.sortDesc = [!currentDesc];
      } else {
        this.appOptions.sortBy = [header.value];
        this.appOptions.sortDesc = [false];
      }
    },

    selectCertType() {
      const selectedCert = this.filterItems.certificatesCategoryFilter;
      if (!selectedCert) {
        this.filterItems.countryId = null;
      } else if (selectedCert != 17 && this.countriesList.length > 0) {
        this.filterItems.countryId = this.countriesList[0].id;

      }
      return this.$http
          .post("/api/students_admission_apps/get_certificate_type_filter/", {
            categoryId: this.filterItems.certificatesCategoryFilter || 0
          })
          .then(response => {
                const data = response.data.data;
                this.certificateTypesList = data.certificatesTypes['basic_category_items']
              },
              err => {
                this.showToasted("error", err.response.data.message);
              })
          .then(() => (this.loading = false));
    },
    checkItem(item) {
      const {studentId, appNum, selected} = item;
      const outputObj = {studentId, applyId: appNum, selected};
      if (outputObj.selected) {
        const itemToAdd = {...outputObj};
        delete itemToAdd.selected;
        this.selectedItems.push(itemToAdd);
      } else {
        const index = this.selectedItems.findIndex(
            (selectedItem) => selectedItem.studentId === outputObj.studentId &&
                selectedItem.applyId === outputObj.applyId
        );
        if (index !== -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    toggleSelectAll() {
      const isChecked = this.selectAll;
      this.selectedItems = [];
      if (isChecked) {
        const keysToKeep = ['studentId', 'appNum'];
        const listAppPaging = this.applications
        listAppPaging.forEach((app) => {
          const filteredApp = {};
          keysToKeep.forEach((key) => {
            if (key === 'appNum') {
              filteredApp['applyId'] = app[key];
            } else {
              filteredApp[key] = app[key];
            }
          });
          this.selectedItems.push(filteredApp);
        });


      }
      this.applications.forEach((item) => {
        item.selected = isChecked;
      });

    },

    showScopeTreeFn() {
      this.showScopeTree = true;
      this.componentKey += 1;
    },
    getFilters(facultyId = null) {
      return this.$http
          .post("/api/students_admission_apps/list_application_filters/")
          .then(response => {
                const data = response.data.data;
                const modifiedStatus = [{
                  name: this.$t('ALL'),
                  id: 'all',
                  'mongo_id': 'all',
                  'ordering': 0
                }, ...data.applicationStatus]
                this.status = modifiedStatus;
                this.years = data.years;
                this.semesters = data.Semesters;
                this.certificateCategoriesList = data.certificateCategories['basic_category_items'];
                this.foreignCertificatesList = data.foreignCertificates;
                this.egyptianCertificatesList = data.egyptianCertificates;
                this.countriesList = data.countries['countriesList'];
                this.currentYear = this.years.filter(year => parseInt(year.active) === 1)[0];
                this.currentSemester = this.semesters.filter(semester => parseInt(semester.active) === 1)[0];
                this.filterItems.yearId = this.currentYear.id || 0;
                this.filterItems.yearName = this.currentYear.name || "";
                this.filterItems.semesterId = this.currentSemester.id || 0;
                this.filterItems.semesterName = this.currentSemester.name || "";


              },
              err => {
                this.showToasted("error", err.response.data.message);
              })
          .then(() => (this.loading = false));
    },

    initializeList() {
      return new Promise((resolve, reject) => {
        const data = this.searchedData();
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.$http
              .post("/api/students_admission_apps/list_applications/", data)
              .then(
                  res => {
                    this.applications = [];
                    const items = res.data.data.results;
                    const itemsWithSelected = items.map(item => ({
                      ...item,
                      selected: false
                    }));
                    const total = res.data.data.total;
                    const sendingApplications = res.data.data.sendingApplications;
                    this.sendingApplications = sendingApplications;
                    resolve({
                      itemsWithSelected,
                      total,
                      sendingApplications
                    });
                  },
                  err => {
                    this.applications = [];
                    this.$toasted.show(this.serverTranslate(err.response.data.message),
                        {
                          type: "error",
                          icon: "error_outline",
                          position: "bottom-left",
                          duration: 5000,
                          theme: "bubble"
                        }
                    );
                  }
              );
          this.loading = false;
        }, 1000);
      });
    },

    searchedData() {
      this.loading = true;
      this.selectAll = false
      this.selectedItems = []
      const {sortBy, sortDesc, page, itemsPerPage} = this.appOptions
      const data = {
        studentId: !this.studentId || !this.studentId.id ? "" : this.studentId.id,
        yearId: this.filterItems.yearId || this.activeAcademicYear.id || 0,
        preQualYearId: this.filterItems.preQualYear || 0,
        semesterId: this.filterItems.semesterId || this.activeAcademicSemester.id || 0,
        studentLimit: this.filterItems.studentLimit || 0,
        identityType: this.searchWithId || "",
        inputPercFilterValue: this.inputPercFilterValue || "",
        selectedOperator: (this.inputPercFilterValue ? this.selectedOperator : ''),
        inputTotFilterValue: this.inputTotFilterValue || "",
        selectedTotOperator: (this.inputTotFilterValue ? this.selectedTotOperator : ''),
        totSelcVal: (this.totSelcVal ? this.totSelcVal : ''),
        searchText: this.identityNum || this.appId || this.desireNum || "",
        appStatus: (this.appStatus && this.appStatus != 'all' && Array.isArray(this.appStatus) ? this.appStatus.flat() : ""),
        startApplicationDate: this.startApplicationDate,
        endApplicationDate: this.endApplicationDate,
        certificateTypeId: this.filterItems.certificateTypeFilter || "",
        certificateCategoryId: this.filterItems.certificatesCategoryFilter || "",
        countryId: this.filterItems.countryId || "",
        certificateForeignId: this.certificateForeignId || "",
        withSubmittedTotalOnly: this.withSubmittedTotalOnly,
        notificationFlag: true,
        paid: this.paidOnly,
        page: page,
        pageSize: itemsPerPage
      }
      if (sortBy.length === 1 && sortDesc.length === 1) {
        data.orderType = sortDesc[0] ? "asc" : "desc";
        data.orderBy = sortBy[0]
      }
      return data
    },
    searchAppliactions(resetPageNum = false) {
      if (resetPageNum) {
        this.appOptions.page = 1;
        this.appOptions.sortBy = [];
        this.appOptions.sortDesc = [];
      }
      this.initializeList()
          .then(data => {
            this.applications = data.itemsWithSelected;
            this.total = data.total;
          });
    },
    reset() {
      this.filterItems.yearId = this.currentYear.id;
      this.filterItems.semesterId = this.currentSemester.id;
      //this.filterItems.certificateTypeFilter = '';
      this.filterItems.countriesList = '';
      this.filterItems.studentLimit = '';
      this.studentId = null;
      this.students = [];
      this.identityNum = "";
      this.searchWithId = "1";
      this.appStatus = "all"
      this.paidOnly = false;
      this.studentSearch = "";
      this.startApplicationDate = "";
      this.endApplicationDate = "";
      this.certificateForeignId = "";
      this.inputPercFilterValue = '';
      this.inputTotFilterValue = '';
      this.selectedOperator = '';
      this.selectedTotOperator = '';
      this.totSelcVal = null;
      this.searchAppliactions(true);
    },
    openMessageDialog() {
      if (this.selectedItems.length > 0) {
        this.resetSendingForm();
        //     this.$refs.formMessage.resetValidation();

        this.openDialog = true;
        this.showAlert = false;
        this.errorMessages = "";
      } else {
        this.openDialog = false;
        this.showAlert = true;
        this.errorMessages = this.$t("ERROR_MESSAGES.NO_STUDENT_SELECTED");
      }

    },
    onScopeChanged(changed) {
      if (changed)
        this.searchAppliactions(true);
    },
    closeSendingDialog() {
      this.resetSendingForm();
      this.$refs.formMessage.resetValidation();
      this.openDialog = false;
      this.showAlert = false;
      this.errorMessages = "";
    },
    resetSendingForm() {
      this.notificationMessage = '';
      //this.feedbackCheckbox = "0";
      this.applicationStatusOption = ""
      this.sendMailToStudent = "0";
      //   this.$refs.formMessage.resetValidation();
    },

    isNotEmpty(str) {
      return !(!str || 0 === str.length || /^\s*$/.test(str));
    },


    sendAllNotifications() {
      //  this.sentNotification = true;
      if (this.$refs.formMessage.validate()) {
        let selectedApplications = [];
        if (this.selectedItems && this.selectedItems.length) {
          selectedApplications = this.selectedItems;
        } else {
          selectedApplications = this.sendingApplications;
        }
        this.$http
            .post("/api/students_admission_apps/send_notifications/", {
              message: this.notificationMessage,
              //feedbackCheck: parseInt(this.feedbackCheckbox),
              applicationStatusOption: this.applicationStatusOption,
              sendingApplications: selectedApplications,
              sendMessageGroup: this.sendMessageGroup,
              sendMailToStudent: this.sendMailToStudent

            })
            .then(response => {
              this.closeSendingDialog();
              this.showToasted("success", response.data.message);
              this.searchAppliactions(true);

              //   this.sentNotification = false;

            })
            .catch(errors => {
              // this.dialog = true;
              this.closeSendingDialog();
              this.showToasted("error", errors.response.data.message);
            });
      } else {
        this.showAlert = true;
        this.errorMessages = this.$t("COMPLETE_DATA_ERROR");
      }


    }
  }
};
</script>
  